import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202509: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202509",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-09-01",
  endDate: "2025-09-30",
  impressions: 11386,
  clicks: 200,
  adsSpendDollars: 1008,
  budgetDollars: 1500,
  salesDollars: 3778,
  bestEstimateRoas: 3.75,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.67,
  newCustomersAcquired: 6,
  dataAvailableAtDate: "2025-10-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
